export default __webpack_public_path__ + "e28dda8b625d042b1585c59dafbeb7ce.png";